import { BroadsiderArticle, BroadsiderFooter, ScreenFrame, LoadingSpinner } from '../components';
import { useContentful } from '../hooks';
import { renderRichText } from '../utils';

const PPTitle = () => {
  return (
    <div className='article-title-main-text'>
      Privacy Policy
    </div>
  );
};

export default function PP() {
  const { isLoading, articles } = useContentful();
  if (isLoading) {
    return (<div className='page'><LoadingSpinner /></div>);
  }

  return (
    <div className='page'>
      <ScreenFrame>
        <BroadsiderArticle title={<PPTitle />} imageUrl='/assets/broadside_header_red.png' noImage>
	  {renderRichText(articles['PP'])}
        </BroadsiderArticle>
      </ScreenFrame>
      <BroadsiderFooter/>
    </div>
  );
}
